/* eslint-disable @typescript-eslint/no-explicit-any */
import { fileToBase64 } from '@/utils/functions/toBase64'
import { GeneratedFormPayloadTypes, GeneratedFormSpecTypes } from '@/utils/types/generatedForm'
import moment from 'moment'

export const createPayloadGenerateForm = async (
  payload: GeneratedFormPayloadTypes,
  alurkerjaSpec: GeneratedFormSpecTypes[],
) => {
  const body: any[] = []
  for (const field of alurkerjaSpec) {
    const fieldName = field.name

    if (field.form_field_type === 'INPUT_SWITCH') {
      payload[fieldName] = payload[fieldName] ? 'true' : 'false'
    } else if (!payload[fieldName]) {
      continue
    }

    const fileUploadResult = await handleFileUpload(field, payload)
    const multiFileUploads = await handleMultiFileUpload(field, payload)
    if (fileUploadResult) {
      body.push(fileUploadResult)
      continue
    }
    if (multiFileUploads) {
      body.push(...multiFileUploads)
      continue
    }
    let type = 'String'

    let value = payload[fieldName as keyof GeneratedFormPayloadTypes]

    if (field.form_field_type === 'INPUT_NUMBER') {
      value = Number.parseFloat(value)
    } else if (field.form_field_type === 'INPUT_DATETIME-LOCAL') {
      value = moment(value).format('DD-MM-YYYY HH:mm')
    } else if (field.form_field_type === 'INPUT_DATE') {
      value = moment(value).format('DD-MM-YYYY')
    } else if (field.form_field_type == 'INPUT_SWITCH') {
      value = value == 'true' ? 1 : 0
      type = 'Boolean'
    } else if (field.name == 'companyId') {
      type = 'Integer'
    }
    body.push({
      name: fieldName,
      value: value,
      type: type,
    })
  }
  return body
}

const handleFileUpload = async (field: GeneratedFormSpecTypes, payload: GeneratedFormPayloadTypes) => {
  if (field.form_field_type === 'INPUT_IMAGE_UPLOAD' || field.form_field_type === 'INPUT_FILE_UPLOAD') {
    const imageData = await fileToBase64(payload[field.name])
    if (imageData) {
      return {
        name: field.name,
        value: (imageData as string).toString().split(',')[1],
        valueInfo: {
          filename: payload[field.name].name,
          mimeType: payload[field.name].type,
        },
        type: 'File',
      }
    }
  }

  return null
}

const handleMultiFileUpload = async (field: GeneratedFormSpecTypes, payload: GeneratedFormPayloadTypes) => {
  if (field.form_field_type === 'INPUT_MULTI_FILE_UPLOAD') {
    const files = payload[field.name] as File[]
    if (files && files.length > 0) {
      const filePromises = files.map(async (file, index) => {
        const fileData = await fileToBase64(file)
        if (fileData) {
          return {
            name: `${field.name}${index > 0 ? `_${index}` : ''}`,
            value: (fileData as string).toString().split(',')[1],
            valueInfo: {
              filename: file.name,
              mimeType: file.type,
            },
            type: 'File',
          }
        }
      })
      return await Promise.all(filePromises)
    }
  }
  return null
}
